import { useAsync } from "@/migrated-widgets/table-map/hooks/useAsync";
import { MapDataLayerService } from "../../services";
import { useGlobal } from "../../contexts/GlobalState";
import dayjs from "dayjs";
import { GetCompetitorsModelLevelDataResponse } from "../../services/MapDataLayer/types/Competitors.types";

export const useCompetitorsMarkers = () => {
    const { params, tableMapConfig } = useGlobal();

    const showTransactions = tableMapConfig?.showTransactions !== false;

    const { response: competitorsMarkers = [], loading: loadingCompetitors = true } = useAsync(async () => {
        if (!showTransactions) {
            return [];
        }
        
        const res = await MapDataLayerService.get<GetCompetitorsModelLevelDataResponse>("/salescompetitor", {
            level: "competitor",
            startDate: dayjs(params.startDate).format("YYYY/MM/DD"),
            endDate: dayjs(params.endDate ?? new Date()).format("YYYY/MM/DD"),
            dealerId: params.dealerRefId,
            token: params.token,
        });

       const competitorsMarkers = res.elementCollection.map((competitor) => ({
            id: competitor.competitorName,
            label: competitor.competitorName,
            position: {
                lat: parseFloat(competitor.latitude),
                lng: parseFloat(competitor.longitude),
            },
        }));

        return competitorsMarkers;
    }, [params, tableMapConfig]);

    return {
        competitorsMarkers,
        loadingCompetitors,
    };
};
